import React from 'react';
import ServiceInfo from '../ServiceInfo';
import { Link } from 'react-router-dom';
import TrackVisibility from 'react-on-screen';
import CommonButton from '../../../utility/components/CommonButton';
import './ServiceGrid.css';

// Service card component
export const ServiceCard = ({ id, ServiceImg, ServiceName }) => {
    const imageSrc = require(`../../../assets/img/${ServiceImg}`)

    return (
        <div className='service-card__container'>
            <Link to={`/service/${id}`}>
                <div className={`service-card animate__animated animate__fadeIn`} style={{ backgroundImage: `url(${imageSrc})` }}>
                    <h2 className={`service-card__title `}>{ServiceName}</h2>
                    <CommonButton presetStyle='light' customClass='service-card__button' size='large'>Explore</CommonButton>
                </div>
            </Link>  
        </div>
    );
};

export const ServiceGrid = () => {
    return (
        <TrackVisibility once>
            {({ isVisible }) =>
                <div className={`service-grid`}>
                    <div className={`service-grid__title ${isVisible ? 'animate__animated animate__fadeInUp' : ''}`}>
                        <h1>Services</h1>
                    </div>
                    
                    <div className={`service-grid__cards-container ${isVisible ? 'animate__animated animate__fadeIn' : ''}`}>
                        {ServiceInfo.map(service => (
                            <ServiceCard
                                key={service.id}
                                id={service.id}
                                ServiceImg={service.ServiceImg}
                                ServiceName={service.ServiceName}
                            />
                        ))}
                    </div>

                </div>
            }
        </TrackVisibility>
    );
};